import { useMemo } from 'react'

import { useCard } from '@/hooks/useCard'
import { useReduxSelector } from '@/store/hooks'
import { selectors } from '@/store/selectors'
import { getCardImage } from '@/utils/cardUtil'

type Props = {
  name?: string
} & Parameters<typeof useCard>[0]

export const useCardFaceProps = ({ cardId, enabled, name }: Props) => {
  const { card, hasError, loading } = useCard({ cardId, enabled })
  const scryfallId = useReduxSelector((s) => selectors.alternateArt(s, cardId))

  return useMemo(() => {
    const flags = {
      hasContentWarning: card?.hasContentWarning,
      hasError,
      isBanned: card?.isBanned,
      isUnofficial: card?.isUnofficial,
      loading,
    }

    const { imageBack, nameBack } = card || {}
    const back =
      imageBack && nameBack
        ? {
            ...flags,
            image: getCardImage({ face: 'back', scryfallId }) || imageBack,
            name: nameBack,
          }
        : undefined

    return {
      back,
      front: {
        ...flags,
        image: getCardImage({ scryfallId }) || card?.image,
        name: card?.nameFront || card?.name || name,
      },
    }
  }, [name, card, hasError, loading, scryfallId])
}
